/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 30/11/2023
 */
import BaseObject from "@shared/BaseObject.js";
import {AccessScopeEnum} from "@shared/Permissions/PermissionsEnum.js";

export default class AccessScopeItem extends BaseObject {

	clients: AccessScopeEnum = AccessScopeEnum.ASSIGNED_ENTRIES
	resources: AccessScopeEnum = AccessScopeEnum.ASSIGNED_ENTRIES
	schedulers: AccessScopeEnum = AccessScopeEnum.ASSIGNED_ENTRIES

	constructor() {
		super();
	}

}
